import { Map } from 'immutable'
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { connect as connectRedux } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Button, { TYPES } from '../Button/index'
import { ICON_TYPES } from '../Icon.v2/index'
import { getBoundActions } from '../../actions/index'
import { SHARE_TOOLTIP_MAX_COUNT } from '../../services/feature-tracking/constants'
import Sherpa, { TYPE_STATIC_ROYAL } from '../Sherpa/index'
import Gift from '../Icon/icons/Gift/index'

const TOOLTIP_ACTIVATION_TIMEOUT = 1000

function ShareTooltip (props) {
  const {
    auth,
    isMobile,
    buttonRef,
    staticText,
    handleShareClick,
    shareTooltipCount,
    featureTrackingProcessing,
    setFeatureTrackingDataPersistent,
  } = props

  const tooltipTailRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)
  const [isCountUpdated, setIsCountUpdated] = useState(false)

  const onShareClick = () => {
    handleShareClick()
    setIsVisible(false)
  }

  const setTailPosition = useCallback(() => {
    if (buttonRef && buttonRef.current && tooltipTailRef && tooltipTailRef.current) {
      const left = buttonRef.current.offsetLeft
      const parentOffset = buttonRef.current.parentNode.offsetLeft
      tooltipTailRef.current.style.left = `${left - parentOffset + 8}px`
    }
  }, [tooltipTailRef, buttonRef])

  const updateCount = useCallback((count) => {
    if (!isCountUpdated) {
      setFeatureTrackingDataPersistent({
        data: Map({ shareTooltipCount: count }),
        auth,
      })
      setIsCountUpdated(true)
    }
  }, [isCountUpdated, setFeatureTrackingDataPersistent])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!featureTrackingProcessing
        && shareTooltipCount < SHARE_TOOLTIP_MAX_COUNT
        && buttonRef
        && buttonRef.current
      ) {
        setIsVisible(true)
        updateCount(shareTooltipCount + 1)
      }
    }, TOOLTIP_ACTIVATION_TIMEOUT)
    return () => {
      clearTimeout(timer)
    }
  }, [featureTrackingProcessing, shareTooltipCount, buttonRef, updateCount])

  useEffect(() => {
    if (isVisible) {
      setTailPosition()
    }
    global.addEventListener('resize', setTailPosition)
    return () => {
      global.removeEventListener('resize', setTailPosition)
    }
  }, [isVisible, setTailPosition])

  useEffect(() => {
    setTailPosition()
  }, [isMobile])

  if (!isVisible) {
    return null
  }

  return (
    <div className="share-tooltip">
      <div className="share-tooltip__tail" ref={tooltipTailRef} />
      <div className="share-tooltip__content">
        <Button
          onClick={() => {
            setFeatureTrackingDataPersistent({
              data: Map({ shareTooltipCount: SHARE_TOOLTIP_MAX_COUNT }),
              auth,
            })
            setIsVisible(false)
          }}
          className="share-tooltip__close"
          icon={ICON_TYPES.CLOSE}
          type={TYPES.ICON}
        />
        <div className="share-tooltip__content-section">
          <Sherpa type={TYPE_STATIC_ROYAL} />
          <div>
            <p className="share-tooltip__title">
              <span>{staticText.get('quickTip')} </span>
              {staticText.get('title')}
            </p>
            <p className="share-tooltip__description">
              {staticText.get('descriptionFirstLine')}
              <span> {staticText.get('descriptionSecondLine')}</span>
            </p>
          </div>
        </div>
        <Button
          type={TYPES.ICON}
          iconSvg={<Gift />}
          className="share-tooltip__button"
          onClick={onShareClick}
        >
          <span className="share-tooltip__button-label">
            {staticText.get('buttonText')}
          </span>
        </Button>
      </div>
    </div>
  )
}

ShareTooltip.propTypes = {
  handleShareClick: PropTypes.func.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  shareTooltipCount: PropTypes.number,
  shareVideoTfeatureTrackingProcessingooltip: PropTypes.bool,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
}

export default connectRedux(({
  auth,
  staticText,
  featureTracking,
}) => ({
  auth,
  staticText: staticText.getIn(['data', 'shareTooltip', 'data'], Map()),
  shareTooltipCount: featureTracking.getIn(['data', 'shareTooltipCount']),
  featureTrackingProcessing: featureTracking.get('processing'),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
  }
})(ShareTooltip)
